import { EmployeeProductivityDetail } from "components/hr-metrics/employee-productivity/EmployeeProductivityDetail";
import { INITIAL_DATA_QUERY_EMPLOYEE_PRODUCTIVITY_DETAIL } from "configs/hr-metrics/configTableEmployeeProductivityList";
import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { API_EMPLOYEE_PRODUCTIVITY } from "services/apiEmployeeProductivity";
import { useFetch } from "services/useFetch";
import { downloadFile, getAllQueryParams, setQueryParams } from "utils/utils";

const FILTER_PARAMS = ['departments', 'divisions']

const EmployeeProductivityDetailContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const periodId = searchParams.get('periodId')
    const [isShowToast, setIsShowToast] = useState(false)
    const [toastMessage, setToastMessage] = useState('')
    const [selectedIds, setSelectedIds] = useState([])
    const [modal, setModal] = useState({
        limit: false
    })
    const [queryFilter, setQueryFilter] = useState()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_QUERY_EMPLOYEE_PRODUCTIVITY_DETAIL
    const {data: detailList, fetching: getDetail, isLoading} = useFetch({...API_EMPLOYEE_PRODUCTIVITY.DETAIL, initPathVariable: periodId}, INITIAL_DATA_QUERY_EMPLOYEE_PRODUCTIVITY_DETAIL)    
    const {fetching: exportEmployeeProductivity} = useFetch({...API_EMPLOYEE_PRODUCTIVITY.EXPORT_EMPLOYEE, initPathVariable: periodId})    

    useEffect(() => {
        getDetailList()
    }, [location?.search])

    const getDetailList = async () => {
        const newQuery = {...query}
        const newQueryFilter = {}
        Object.entries(newQuery).forEach(([key, item]) => {
            if (FILTER_PARAMS.includes(key)) {
                const valueOfQuery = FILTER_PARAMS.includes(key) ? item.split(',') : item
                newQuery[key] = valueOfQuery
                newQueryFilter[key] = valueOfQuery
            }
        })
        setQueryFilter(newQueryFilter)
        getDetail(newQuery)
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({...query, ...queryParams})
        setSearchParams(params, {replace: true})
    }

    const clearToast = () => {
        setIsShowToast(false)
        setToastMessage('')
    }

    const showToast = (message) => {
        setIsShowToast(true)
        setToastMessage(message)
    }

    const setShowModal = (value) => {
        setModal({...modal, ...value})
    }

    const onExportHandler = () => {
        const { page, limit, ...payload } = query
        const body = {...payload, productivity_ids: selectedIds.map(item => item.id )}

        exportEmployeeProductivity(body, '', {}, 'blob')
            .then(res => {
                downloadFile(null, res, `Employee-Productivity-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
                setShowModal({export: false})
                showToast('Export Data Berhasil !!')
            })
    }

    const props = {
        dataList: detailList?.data,
        isLoading,
        query,
        queryFilter,
        modal,
        selectedIds,
        toast: {
            isShowToast,
            message: toastMessage
        },
        clearToast,
        onChangeQuery,
        setShowModal,
        setSelectedIds,
        onExportHandler,
    }

    return (
        <EmployeeProductivityDetail {...props}/>
    )
}

export default EmployeeProductivityDetailContainer
